__turbopack_context__.v({
  "caret": "agent-terminal-module__iTwIBa__caret",
  "caretBlink": "agent-terminal-module__iTwIBa__caretBlink",
  "line": "agent-terminal-module__iTwIBa__line",
  "lineIn": "agent-terminal-module__iTwIBa__lineIn",
  "tabStrip": "agent-terminal-module__iTwIBa__tabStrip",
  "terminal": "agent-terminal-module__iTwIBa__terminal",
});
